export default function blockLogotypes() {
    const sliders = document.querySelectorAll(
        '.logotypes-slider:not(.logotypes-slider--disabled)');
    if (sliders.length === 0) return;
    return import('swiper/bundle').then(({default: Swiper}) => {
        sliders.forEach(function (slider) {
            const sliderItems = slider.querySelectorAll('.logotypes-slider__item');
            const swiper = new Swiper(slider, {
                speed: 1000,
                spaceBetween: 2,
                autoplay: {
                    delay: 4000,
                    disableOnInteraction: true,
                },
                navigation: {
                    nextEl: slider.querySelector('.logotypes-slider__arrow--next'),
                    prevEl: slider.querySelector('.logotypes-slider__arrow--prev'),
                },
                breakpoints: {
                    0: {
                        slidesPerView: 2,
                        loop: sliderItems.length > 2,
                    },
                    768: {
                        slidesPerView: Math.ceil(parseInt(slider.dataset.cols) / 2),
                        loopAdditionalSlides: 0,
                        loop: sliderItems.length > Math.ceil(parseInt(slider.dataset.cols) / 2),
                    },
                    // when window width is >= 480px
                    1200: {
                        slidesPerView: parseInt(slider.dataset.cols),
                        loop: sliderItems.length > parseInt(slider.dataset.cols),
                    },
                },
            });
        });
    });
}